(function () {
  function norm(s) {
    return (s || "")
      .toString()
      .normalize("NFKC")
      .replace(/\u00A0/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  }

  function setVisible(el, visible) {
    el.setAttribute("aria-hidden", visible ? "false" : "true");
    el.style.display = visible ? "" : "none";
    el.style.opacity = visible ? "1" : "0";
    el.style.visibility = visible ? "visible" : "hidden";
    el.style.pointerEvents = visible ? "" : "none";
  }

  function getVariantId(scope) {
    const idInput =
      scope.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      scope.querySelector('input[name="id"]');
    return idInput ? idInput.value : null;
  }

  function getPendingColor(scope) {
    return norm(scope?.dataset?.ewPendingColor || "");
  }

  function setPendingColor(scope, color) {
    const value = norm(color);
    if (value) {
      scope.dataset.ewPendingColor = value;
    } else {
      delete scope.dataset.ewPendingColor;
    }
  }

  function getSelectedTokens(scope, forcedColor = "") {
    const forced = norm(forcedColor);
    if (forced) return [forced];

    const pending = getPendingColor(scope);
    if (pending) return [pending];

    const directColor =
      scope.querySelector('input[name="options[Farbe]"]:checked')?.value ||
      scope.querySelector('select[name="options[Farbe]"]')?.value ||
      "";

    const color = norm(directColor);
    return color ? [color] : [];
  }

function filterSwiper(galleryEl, selectedTokens, tryCount = 0) {
  if (!galleryEl) return;

  const swiper = galleryEl.swiper;
  if (!swiper) {
    if (tryCount < 25) {
      setTimeout(() => filterSwiper(galleryEl, selectedTokens, tryCount + 1), 80);
    }
    return;
  }

  const wrapper = galleryEl.querySelector(".swiper-wrapper");
  if (!wrapper) return;

  const slides = Array.from(wrapper.querySelectorAll(".swiper-slide.ew-variant-media"));
  if (!slides.length) return;

  if (!selectedTokens.length) {
    return;
  }

  const selectedColor = selectedTokens[0] || "";
  const knownTags = ["blau", "bunt", "alle"];

  const matched = [];
  const shared = [];
  const unmatched = [];

  slides.forEach((slide) => {
    const alt = norm(slide.getAttribute("data-media-alt"));

    let parts = [];
    if (!alt) {
      parts = [];
    } else if (alt.includes("/")) {
      parts = alt.split("/").map(norm).filter(Boolean);
    } else {
      parts = [alt];
    }

    const tags = parts.filter((p) => knownTags.includes(p));

    const isColorMatch = tags.includes(selectedColor);
    const isShared = tags.includes("alle") || tags.length === 0;

    const isVisible = isColorMatch || isShared;

    setVisible(slide, isVisible);

    if (isColorMatch) matched.push(slide);
    else if (isShared) shared.push(slide);
    else unmatched.push(slide);
  });

  if (!matched.length && !shared.length) {
    slides.forEach((s) => setVisible(s, true));
    swiper.update();
    swiper.slideTo(0, 0);
    return;
  }

  matched.forEach((s) => wrapper.appendChild(s));
  shared.forEach((s) => wrapper.appendChild(s));
  unmatched.forEach((s) => wrapper.appendChild(s));

  const visibleCount = matched.length + shared.length;

  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();
  swiper.update();

  requestAnimationFrame(() => {
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();
    swiper.update();

    if (swiper.activeIndex >= visibleCount) {
      swiper.slideTo(Math.max(visibleCount - 1, 0), 0);
    }
  });
}

  function initSection(scope) {
    updateSelectedButtonTheme(scope);

    const sync = () => {
      applyColorFromUrl(scope);
      updateSelectedButtonTheme(scope);
      run(scope);
    };

    sync();
    requestAnimationFrame(sync);
    setTimeout(sync, 120);
    setTimeout(sync, 300);
  }

  function run(scope, forcedColor = "") {
    const activeColor = norm(forcedColor || getPendingColor(scope) || getCurrentColor(scope));

    if (forcedColor) {
      setPendingColor(scope, forcedColor);
    }

    updateSelectedButtonTheme(scope, activeColor);
    updateDesignButtonImages(scope, activeColor);
    updateLinkedColorParams(scope, activeColor);

    const tokens = getSelectedTokens(scope, activeColor);

    const main = scope.querySelector(".product-media-gallery.swiper");
    const thumbs = scope.querySelector(".product-thumbnails.swiper");

    filterSwiper(main, tokens);
    filterSwiper(thumbs, tokens);

    if (activeColor && norm(getCurrentColor(scope)) === activeColor) {
      setPendingColor(scope, "");
    }
  }

  function getScopeFromTarget(t) {
    return t.closest(".shopify-section") || document;
  }

  function getCurrentColor(scope) {
  const checkedRadio = scope.querySelector('input[name="options[Farbe]"]:checked');
  if (checkedRadio) return checkedRadio.value || "";

  const colorSelect = scope.querySelector('select[name="options[Farbe]"]');
  if (colorSelect) return colorSelect.value || "";

  return "";
}

function updateSelectedButtonTheme(scope, forcedColor = "") {
  const host = scope.querySelector(".mainProduct");
  if (!host) return;

  const directColor = norm(forcedColor);
  const selectedColor = norm(getCurrentColor(scope));
  const params = new URLSearchParams(window.location.search);
  const urlColor = norm(params.get("ew_color"));

  const currentColor = directColor || selectedColor || urlColor;

  if (currentColor === "bunt") {
    host.style.setProperty("--ew-selected-bg", "#FFC6EF");
    host.style.setProperty("--ew-selected-border", "#1F1B64");
    host.style.setProperty("--ew-selected-text", "#1F1B64");
  } else {
    host.style.setProperty("--ew-selected-bg", "#CFE0FF");
    host.style.setProperty("--ew-selected-border", "#1F1B64");
    host.style.setProperty("--ew-selected-text", "#1F1B64");
  }
}

function updateDesignButtonImages(scope, forcedColor = "") {
  const currentColor = norm(forcedColor || getCurrentColor(scope));
  if (!currentColor) return;

  const buttons = scope.querySelectorAll(".ew-design-btn");

  buttons.forEach((button) => {
    const img = button.querySelector(".ew-design-btn__img");
    if (!img) return;

    const defaultSrc = button.dataset.designImageDefault || "";
    const blauSrc = button.dataset.designImageBlau || "";
    const buntSrc = button.dataset.designImageBunt || "";

    let nextSrc = defaultSrc;

    if (currentColor === "blau" && blauSrc) {
      nextSrc = blauSrc;
    } else if (currentColor === "bunt" && buntSrc) {
      nextSrc = buntSrc;
    }

    if (nextSrc && img.getAttribute("src") !== nextSrc) {
      img.setAttribute("src", nextSrc);
    }
  });
}

function updateLinkedColorParams(scope, forcedColor = "") {
  const currentColor = norm(forcedColor || getCurrentColor(scope));

  const links = scope.querySelectorAll(
    ".ew-occasion-buttons a[href], .ew-design-buttons a[href]"
  );

  links.forEach((link) => {
    const rawHref = link.getAttribute("href");
    if (!rawHref) return;

    const url = new URL(rawHref, window.location.origin);

    const blauVariantId = link.dataset.variantBlau || "";
    const buntVariantId = link.dataset.variantBunt || "";

    if (currentColor === "bunt") {
      url.searchParams.set("ew_color", "Bunt");
      if (buntVariantId) {
        url.searchParams.set("variant", buntVariantId);
      } else {
        url.searchParams.delete("variant");
      }
    } else {
      url.searchParams.set("ew_color", "Blau");
      if (blauVariantId) {
        url.searchParams.set("variant", blauVariantId);
      } else {
        url.searchParams.delete("variant");
      }
    }

    link.setAttribute("href", `${url.pathname}${url.search}${url.hash}`);
  });
}

function applyColorFromUrl(scope) {
  const params = new URLSearchParams(window.location.search);
  const requestedColor = norm(params.get("ew_color"));
  if (!requestedColor) return;

  const radios = Array.from(scope.querySelectorAll('input[name="options[Farbe]"]'));
  const matchingRadio = radios.find((radio) => norm(radio.value) === requestedColor);

  if (matchingRadio) {
    if (!matchingRadio.checked) {
      matchingRadio.checked = true;
      matchingRadio.dispatchEvent(new Event("input", { bubbles: true }));
      matchingRadio.dispatchEvent(new Event("change", { bubbles: true }));
    }

    return;
  }

  const colorSelect = scope.querySelector('select[name="options[Farbe]"]');
  if (colorSelect) {
    const matchingOption = Array.from(colorSelect.options).find(
      (option) => norm(option.value) === requestedColor
    );

    if (matchingOption && norm(colorSelect.value) !== requestedColor) {
      colorSelect.value = matchingOption.value;
      colorSelect.dispatchEvent(new Event("input", { bubbles: true }));
      colorSelect.dispatchEvent(new Event("change", { bubbles: true }));
    }

  }
}

document.addEventListener("pointerdown", (e) => {
  const scope = getScopeFromTarget(e.target);

  const colorLabel = e.target.closest('label[for^="option-farbe-"]');
  const colorItem = e.target.closest('.variant-option-item[data-option-value="Farbe"]');

  let input = null;

  if (colorLabel) {
    const inputId = colorLabel.getAttribute("for");
    if (inputId) {
      input = scope.querySelector(`#${CSS.escape(inputId)}`);
    }
  } else if (colorItem) {
    input = colorItem.querySelector('input[name="options[Farbe]"]');
  }

  if (!input || !input.value) return;

  setPendingColor(scope, input.value);
  run(scope, input.value);
});

document.addEventListener("click", (e) => {
  const link = e.target.closest(".ew-occasion-buttons a[href], .ew-design-buttons a[href]");
  if (!link) return;

  const scope = getScopeFromTarget(link);
  const currentColor = norm(getCurrentColor(scope));
  const url = new URL(link.getAttribute("href"), window.location.origin);

  const targetVariantId =
    currentColor === "blau"
      ? (link.dataset.variantBlau || "")
      : currentColor === "bunt"
      ? (link.dataset.variantBunt || "")
      : "";

  if (targetVariantId) {
    e.preventDefault();
    url.searchParams.set("variant", targetVariantId);

    if (currentColor) {
      url.searchParams.set("ew_color", currentColor);
    }

    window.location.href = url.toString();
    return;
  }

  if (currentColor) {
    e.preventDefault();
    url.searchParams.set("ew_color", currentColor);
    window.location.href = url.toString();
  }
});

  document.addEventListener("change", (e) => {
    const scope = getScopeFromTarget(e.target);

    if (
      e.target.matches('input[name="options[Farbe]"]') ||
      e.target.matches('select[name="options[Farbe]"]')
    ) {
      setPendingColor(scope, e.target.value);
      run(scope, e.target.value);
      return;
    }

    run(scope);
  });

  // Observer für hidden variant id updates
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === "attributes" && m.target && m.target.name === "id") {
        run(getScopeFromTarget(m.target));
      }
    }
  });

  window.addEventListener("load", () => {
    document.querySelectorAll('input[name="id"]').forEach((inp) => {
      mo.observe(inp, { attributes: true, attributeFilter: ["value"] });
    });

    document.querySelectorAll(".shopify-section").forEach((sec) => {
      initSection(sec);
    });
  });
})();